import { Action, ActionType, BlueprintField, BlueprintType, IBlueprintDTO } from './blueprint.types';

export enum MeetingTemplateLinkType {
    Other = 'Other'
}

export interface MeetingTemplateLink {
    label: string;
    url: string;
    type: MeetingTemplateLinkType;
}

export interface StatusMeetingTemplateField extends BlueprintField {
    name: 'status';
    value: string;
}

export interface AccessMeetingTemplateField extends BlueprintField {
    name: 'meetingAccess';
    value: string;
}

export interface ReplayMeetingTemplateField extends BlueprintField {
    name: 'replayEnabled';
    value: boolean;
}

export interface FeaturedMeetingTemplateField extends BlueprintField {
    name: 'featured';
    value: boolean;
}

export interface TypeMeetingTemplateField extends BlueprintField {
    name: 'type';
    value: string;
}

export interface TrackMeetingTemplateField extends BlueprintField {
    name: 'track';
    value: string;
}

export interface TopicMeetingTemplateField extends BlueprintField {
    name: 'topic';
    value: string;
}

export interface NotesMeetingTemplateField extends BlueprintField {
    name: 'notes';
    value: string;
}

export interface ConnectionTemplateIdMeetingTemplateField extends BlueprintField {
    name: 'connectionsBlueprintId';
    value: string;
}

export interface LinksMeetingTemplateField extends BlueprintField {
    name: 'links';
    value: MeetingTemplateLink[];
}

export interface PageLabelMeetingTemplateField extends BlueprintField {
    name: 'label';
    value: string;
}
export interface PagePathMeetingTemplateField extends BlueprintField {
    name: 'path';
    value: string;
}

export interface PageLinkDescriptionTemplateField extends BlueprintField {
    name: 'linkDescription';
    value: string;
}

export interface PageLinkEnabledTemplateField extends BlueprintField {
    name: 'pageLinkEnabled';
    value: boolean;
}

export interface LandingPageTemplateField extends BlueprintField {
    name: 'landingPage';
    value: boolean;
}

export interface DisableOtherPagesTemplateField extends BlueprintField {
    name: 'disableOtherPages';
    value: boolean;
}

export interface RecordEnabledMeetingTemplateField extends BlueprintField {
    name: 'recordEnabled';
    value: boolean;
}

export interface ExpiryDaysMeetingTemplateField extends BlueprintField {
    name: 'expiryDays';
    value: number | null;
}

export type IMeetingsTemplateField =
    StatusMeetingTemplateField
    | AccessMeetingTemplateField
    | ReplayMeetingTemplateField
    | FeaturedMeetingTemplateField
    | TypeMeetingTemplateField
    | TrackMeetingTemplateField
    | TopicMeetingTemplateField
    | NotesMeetingTemplateField
    | LinksMeetingTemplateField
    | PageLabelMeetingTemplateField
    | PagePathMeetingTemplateField
    | PageLinkDescriptionTemplateField
    | PageLinkEnabledTemplateField
    | LandingPageTemplateField
    | DisableOtherPagesTemplateField
    | ConnectionTemplateIdMeetingTemplateField
    | RecordEnabledMeetingTemplateField
    | ExpiryDaysMeetingTemplateField
;

export interface SingleMeetingCustomPageAction extends Action {
    order: 0;
    type: ActionType.SINGLE_MEETING_CUSTOM_PAGE;
}

export interface SingleMeetingConnectionsAction extends Action {
    order: 1;
    type: ActionType.SINGLE_MEETING_CONNECTIONS;
}

export type MeetingTemplateAction = SingleMeetingCustomPageAction | SingleMeetingConnectionsAction;

export interface IMeetingTemplateDTO extends IBlueprintDTO {
    type: BlueprintType.MEETING;
    fields: IMeetingsTemplateField[];
    actions: MeetingTemplateAction[];
}

export interface ICreateMeetingTemplateDTO extends Exclude<IMeetingTemplateDTO, 'blueprintId' | 'createdAt' | 'updatedAt'> {}
